import React, { Component } from 'react';
import ProjectThumb from '../projects/ProjectThumb'

import ThrownInTheDungeonIcon from '../../images/projects/ThrownInTheDungeon.jpg'
import RailTonIcon from '../../images/projects/RailTon.jpg'
import TheShipwreckIcon from '../../images/projects/TheShipwreck.jpg'
import DefenderTraineeIcon from '../../images/projects/DefenderTrainee.jpg'
import TankIcon from '../../images/projects/Tank.jpg'
import HalloweenNightmareLogo from '../../images/projects/HalloweenNightmare.jpg'
import DontMessWithUsLogo from '../../images/projects/DontMessWithUs.jpg'
import ISSLogo from '../../images/projects/ISS.jpg'
import ZeldiabloIcon from '../../images/projects/Zeldiablo.jpg'
import DeflanderIcon from '../../images/projects/Deflander.jpg'

class Projects extends Component {

  constructor(props){
    super(props);

    this.state = { openedProject : null };
  }

  render() {
    return (
    <div className="page" id={this.props.id}>
        <div className="page-container">
            <h2>Projects</h2>

            <div className='grid-list'>
                <ProjectThumb name="Thrown in the dungeon" image={ThrownInTheDungeonIcon} page="thrown-in-the-dungeon" tech="Unity"/>
                <ProjectThumb name="RailTon" image={RailTonIcon} page="railton" tech="Custom C++ engine"/>
                <ProjectThumb name="The Shipwreck" image={TheShipwreckIcon} page="the-shipwreck" tech="Unity"/>
                <ProjectThumb name="Defender Trainee" image={DefenderTraineeIcon} page="defender-trainee" tech="Unreal C++"/>
                <ProjectThumb name="Jeu de tank" image={TankIcon} page="tank" tech="Unity"/>
                <ProjectThumb name="Halloween nightmare" image={HalloweenNightmareLogo} page="halloween-nightmare" tech="Unreal Blueprint"/>
                <ProjectThumb name="Don't mess with us" image={DontMessWithUsLogo} page="dont-mess-with-us" tech="Java"/>
                <ProjectThumb name="ISS" image={ISSLogo} page="iss" tech="Unity"/>
                <ProjectThumb name="Zeldiablo" image={ZeldiabloIcon} page="zeldiablo" tech="Java"/>
                <ProjectThumb name="Deflander" image={DeflanderIcon} page="deflander" tech="Unity"/>
            </div>
        </div>
    </div>
    );
  }
}

export default Projects;